import { Ref, forwardRef } from "react"
import { Form, Formik, FormikProps } from "formik"
import { MerchantFormContent } from "./MerchantFormContent"
import { CreateUpdateMerchantFormValues } from "../../../../../supplier/admin/merchant/merchants/supplierMerchantsTypes"
import { useMerchantValidationSchema } from "../hooks/useMerchantValidationSchema"

type EditMerchantAccountFormProps = Readonly<{
    initialValues: CreateUpdateMerchantFormValues
    onSubmit: (formData: any) => void
}>

type FormikRef = Ref<FormikProps<CreateUpdateMerchantFormValues>>

export const UpdateMerchantForm = forwardRef(
    ({ initialValues, onSubmit }: EditMerchantAccountFormProps, ref: FormikRef) => {
        const validationSchema = useMerchantValidationSchema()

        function handleSubmit(values: CreateUpdateMerchantFormValues) {
            onSubmit(values)
        }

        return (
            <Formik<CreateUpdateMerchantFormValues>
                enableReinitialize
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                innerRef={ref}
            >
                <Form>
                    <MerchantFormContent />
                </Form>
            </Formik>
        )
    },
)
